import { MainTitle } from 'common/text';
import BackButton from 'common/buttons/back';
import { Content } from 'common/containers';
import EditCompanyForm from 'components/forms/products/edit';
import useFetchData from 'hooks/useFetchData';
import Skeleton from 'common/skeleton';
import { useParams } from 'react-router-dom';
const ProductEdit = () => {
	const { id } = useParams<{ id: string }>();
	const { response, isLoading } = useFetchData(`products/${id}`);
	return (
		<>
			<MainTitle>
				<h1>Editar producto</h1>
				<BackButton />
			</MainTitle>
			<Content>
				{isLoading && <Skeleton count={10} />}
				{!isLoading && (
					<EditCompanyForm
						data={response}
						id={id}
					/>
				)}
			</Content>
		</>
	);
};
export default ProductEdit;
